import { render, staticRenderFns } from "./followUserCard.vue?vue&type=template&id=004d89ba&scoped=true&"
import script from "./followUserCard.vue?vue&type=script&lang=js&"
export * from "./followUserCard.vue?vue&type=script&lang=js&"
import style0 from "./followUserCard.vue?vue&type=style&index=0&id=004d89ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d89ba",
  null
  
)

export default component.exports